module.exports = __webpack_public_path__ + "img/Company-Album41024x800.3a705bd7.jpg";